module.exports = __webpack_public_path__ + "img/se-ai.edb0c3fa.png";